import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from '../toaster/message.service';

@Injectable({
  providedIn: 'root'
})
export class CustomDialogService {
  static dynamicDialogRefArray:DynamicDialogRef[]=[];
  constructor(private dialogService: DialogService,private messageService:MessageService) { }
  public open(componentType: Type<any>, config: DynamicDialogConfig) {
    let dynamicDialogRef=this.dialogService.open(componentType,config)
    CustomDialogService.dynamicDialogRefArray.push(dynamicDialogRef)
    return dynamicDialogRef
  }
  closeAllOpenDialog()
  {
    CustomDialogService.dynamicDialogRefArray.forEach(dialog=>{
      if(dialog)
      {
        dialog.destroy();
      }
    })
    this.messageService.closeAllDialog();
  }
}
